import { Button, Modal, ModalBody } from "reactstrap";
import { ThankYouSpecialIcon } from "../../assets/designedPickedIcons";
import { Link } from "react-router-dom";

const ThankYouModal = ({ isOpen, setisOpen }) => {
  return (
    <Modal centered isOpen={isOpen} toggle={() => setisOpen((prev) => !prev)}>
      <ModalBody className="bg-white" style={{ borderRadius: "20px" }}>
        <div className="text-center">
          <ThankYouSpecialIcon />
          <h4 className="color-primary-blue f-6">Thank You!</h4>
          <p className="text-center mb-4 mt-3">
            for submitting your details. Your place is currently pending
            approval. We will notify you once our admin team approves it.
          </p>
        </div>
        <div className="px-4 mb-3 ">
          <Link
            to={"/places"}
            className="btn f-6 d-block standard-rounded-btn text-white full-width"
          >
            Go to My Places
          </Link>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ThankYouModal;
